export default "__VITE_ASSET__tztyB2xo__"